<template>
	<div class="group-member-card">
		<div class="member-avatar-wrap">
			<head-image :id="member.userId" :name="member.showNickName" :url="member.headImage" :size="40"
				:online="member.online" :isAddFriend="isAddFriend" :isGroupAdmin="isGroupAdmin"
				:group-id="group && group.id" :member-muted="!!member.isMuted" :member-is-manager="!!member.isManager"
				:member-is-owner="!!group && member.userId == group.ownerId"></head-image>
			<official-tag :user-tag="member.userTag" :user-tag-img="member.userTagImg" size="small"></official-tag>
		</div>
		<div class="member-name" :class="{ 'official-name': member.userTag == 1 }">{{ member.showNickName }}</div>
	</div>
</template>

<script>
import HeadImage from "../common/HeadImage.vue";
import OfficialTag from "../common/OfficialTag.vue";

export default {
	name: "groupMemberCard",
	components: { HeadImage, OfficialTag },
	data() {
		return {};
	},
	props: {
		member: {
			type: Object,
			required: true
		},
		isAddFriend: {
			type: Boolean,
			default: false,
		},
		isGroupAdmin: {
			type: Boolean,
			default: false,
		},
		group: {
			type: Object,
			default: null
		},
	},
	
}
</script>

<style lang="scss">
.group-member-card {
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 54px;

	.member-avatar-wrap {
		position: relative;
		display: flex;
		justify-content: center;

		.official-tag {
			position: absolute;
			left: 50%;
			bottom: -4px;
			transform: translateX(-50%);
			z-index: 1;
		}
	}

	.member-name {
		font-size: 12px;
		text-align: center;
		width: 100%;
		height: 30px;
		line-height: 30px;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden
	}
}
</style>
